import {
  AgencyMarginModel,
  AgencyMarginRequestRecordModel,
} from '@/models/AgencyMargin'

const actions = {
  async SEARCH({ commit }, { id, requestStatus, keyword, pageNo, pageSize }) {
    const query = {
      id: id,
      keyword: keyword,
      requestStatus: requestStatus,
    }
    const searchResult = await AgencyMarginModel.search(query, pageNo, pageSize)
    commit('SET_SEARCH_RESULT', searchResult)
  },
  async DELETE_REQUEST(_, id) {
    let ret = AgencyMarginRequestRecordModel.deleteRequest(id)
    return ret
  },
  /*
  async ADD_AGENCY({ commit, dispatch, state }, { item }) {
    await AgencyApi.addAgency(item)
  },
  async EDIT_AGENCY({ commit, dispatch, state }, { id, body }) {
    await AgencyApi.editAgency(id, body)
  },
  async DELETE_AGENCY({ commit, dispatch, state }, { id }) {
    await AgencyApi.deleteAgency(id)
  },
  */
}

export default actions
